import React, { Component } from 'react';
import EventEmitter, {
  ON_TAB_FOCUS_BLUR,
} from '../../component/helpers/EventEmitter';

class AutoReloadOnFocusBlurComponent extends Component {
  componentDidMount() {
    EventEmitter.subscribe(ON_TAB_FOCUS_BLUR, () => {
      this.reload();
    });
  }

  componentWillUnmount() {
    EventEmitter.unsubscribe(ON_TAB_FOCUS_BLUR, () => {
      this.reload();
    });
  }

  reload() {}
}

export default AutoReloadOnFocusBlurComponent;
